import { compose } from '@bem-react/core';
import {
    Textinput as TextInputPresenter,
    withBaseline,
    withHasClear,
    withSizeM,
    withThemeNormal
} from '@yandex-lego/components/Textinput/desktop';

export const Input = compose(
    withSizeM,
    withHasClear,
    withBaseline,
    withThemeNormal
)(TextInputPresenter);
